var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useQuery, useQueryClient } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { getHeaders } from "../utils/apiUtils";
import { escapeCql } from "./agencyPrefixesService";
import { fetchAllPages } from "../utils/fetchAllPages";
/**
 * Lists ONIX codetables. By default without their items (`includeItems=false`)
 * — every list consumer needs only id / number / name, and the items of all
 * tables together are thousands of rows.
 */
export var fetchOnixCodetables = function (ky_1) {
    var args_1 = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args_1[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([ky_1], args_1, true), void 0, function (ky, filters) {
        var number, numbers, name, _a, offset, _b, limit, _c, includeItems, parts, n, searchParams, baseQuery, res;
        if (filters === void 0) { filters = {}; }
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    number = filters.number, numbers = filters.numbers, name = filters.name, _a = filters.offset, offset = _a === void 0 ? 0 : _a, _b = filters.limit, limit = _b === void 0 ? 20 : _b, _c = filters.includeItems, includeItems = _c === void 0 ? false : _c;
                    parts = [];
                    if (number !== undefined && number !== null && String(number).length > 0) {
                        n = Number(number);
                        parts.push(Number.isFinite(n)
                            ? "number==".concat(n)
                            : "number==\"".concat(escapeCql(String(number)), "\""));
                    }
                    if (numbers && numbers.length > 0) {
                        parts.push("(".concat(numbers.map(function (n) { return "number==".concat(n); }).join(" or "), ")"));
                    }
                    if (name !== undefined && name !== null && name.length > 0) {
                        parts.push("name==\"*".concat(escapeCql(name), "*\""));
                    }
                    searchParams = new URLSearchParams();
                    baseQuery = parts.length > 0 ? parts.join(" and ") : "cql.allRecords=1";
                    searchParams.set("query", "".concat(baseQuery, " sortBy number id"));
                    searchParams.set("offset", String(offset));
                    searchParams.set("limit", String(limit));
                    searchParams.set("includeItems", String(includeItems));
                    return [4 /*yield*/, ky.get("onix-codetables", {
                            searchParams: searchParams,
                            headers: getHeaders(),
                        })];
                case 1:
                    res = _d.sent();
                    if (!res.ok) {
                        throw new Error("Fetch error: ".concat(res.status, " ").concat(res.statusText));
                    }
                    return [2 /*return*/, res.json()];
            }
        });
    });
};
var compareCodepoints = function (a, b) {
    if (a === void 0) { a = ""; }
    if (b === void 0) { b = ""; }
    if (a === b)
        return 0;
    return a < b ? -1 : 1;
};
/**
 * The order of `/onix-codetable-items?query=… sortBy sortOrder value id`:
 * sortOrder ascending with missing values last, then value, then id. The items
 * nested in a codetable are ordered by sortOrder only, and most items have
 * none, so the rest of the order has to be restored here.
 */
var compareOnixCodetableItems = function (a, b) {
    if (a.sortOrder != null && b.sortOrder != null) {
        if (a.sortOrder !== b.sortOrder)
            return a.sortOrder - b.sortOrder;
    }
    else if (a.sortOrder != null) {
        return -1;
    }
    else if (b.sortOrder != null) {
        return 1;
    }
    return compareCodepoints(a.value, b.value) || compareCodepoints(a.id, b.id);
};
/** Ascending, without duplicates — one canonical form for queries and cache keys. */
var normalizeCodetableNumbers = function (numbers) {
    return Array.from(new Set(numbers)).sort(function (a, b) { return a - b; });
};
/**
 * Loads several ONIX codetables together with their items in one request to
 * the (server-cached) `/onix-codetables` endpoint, instead of paging
 * `/onix-codetable-items` table by table. More codetables than one list page
 * holds (100) are paged.
 *
 * @param ky okapi ky instance
 * @param numbers codetable numbers to load
 * @returns items of every requested codetable in picker order; a codetable the
 *   backend does not know has no items
 */
export var fetchOnixCodetablesByNumbers = function (ky, numbers) { return __awaiter(void 0, void 0, void 0, function () {
    var requested, codetables, byNumber;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                requested = normalizeCodetableNumbers(numbers);
                if (requested.length === 0)
                    return [2 /*return*/, {}];
                return [4 /*yield*/, fetchAllPages(function (offset, limit) { return __awaiter(void 0, void 0, void 0, function () {
                        var page;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, fetchOnixCodetables(ky, {
                                        numbers: requested,
                                        offset: offset,
                                        limit: limit,
                                        includeItems: true,
                                    })];
                                case 1:
                                    page = _a.sent();
                                    return [2 /*return*/, { items: page.items, totalRecords: page.totalRecords }];
                            }
                        });
                    }); })];
            case 1:
                codetables = _a.sent();
                byNumber = {};
                requested.forEach(function (n) {
                    byNumber[n] = { onixCodetableItems: [], totalRecords: 0 };
                });
                codetables.forEach(function (codetable) {
                    var _a;
                    if (codetable.number == null || !(codetable.number in byNumber))
                        return;
                    var items = __spreadArray([], ((_a = codetable.onixCodetableItems) !== null && _a !== void 0 ? _a : []), true).sort(compareOnixCodetableItems);
                    byNumber[codetable.number] = {
                        onixCodetableItems: items,
                        totalRecords: items.length,
                    };
                });
                return [2 /*return*/, byNumber];
        }
    });
}); };
export var fetchOnixCodetableItems = function (ky, filters) { return __awaiter(void 0, void 0, void 0, function () {
    var onixCodetableId, onixCodetableNumber, value, description, searchText, _a, offset, _b, limit, parts, escaped, searchParams, baseQuery, res, data, items, total;
    var _c, _d, _e;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0:
                onixCodetableId = filters.onixCodetableId, onixCodetableNumber = filters.onixCodetableNumber, value = filters.value, description = filters.description, searchText = filters.searchText, _a = filters.offset, offset = _a === void 0 ? 0 : _a, _b = filters.limit, limit = _b === void 0 ? 20 : _b;
                parts = [];
                if (onixCodetableId) {
                    parts.push("onixCodetable.id==\"".concat(escapeCql(onixCodetableId), "\""));
                }
                if (onixCodetableNumber !== undefined && onixCodetableNumber !== null) {
                    parts.push("onixCodetable.number==".concat(onixCodetableNumber));
                }
                if (searchText) {
                    escaped = escapeCql(searchText);
                    parts.push("(value==\"*".concat(escaped, "*\" or description==\"*").concat(escaped, "*\")"));
                }
                if (value && value.length > 0) {
                    parts.push("value==\"*".concat(escapeCql(value), "*\""));
                }
                if (description && description.length > 0) {
                    parts.push("description==\"*".concat(escapeCql(description), "*\""));
                }
                searchParams = new URLSearchParams();
                baseQuery = parts.length > 0 ? parts.join(" and ") : "cql.allRecords=1";
                searchParams.set("query", "".concat(baseQuery, " sortBy sortOrder value id"));
                searchParams.set("offset", String(offset));
                searchParams.set("limit", String(limit));
                return [4 /*yield*/, ky.get("onix-codetable-items", {
                        searchParams: searchParams,
                        headers: getHeaders(),
                    })];
            case 1:
                res = _f.sent();
                if (!res.ok) {
                    throw new Error("Fetch error: ".concat(res.status, " ").concat(res.statusText));
                }
                return [4 /*yield*/, res.json()];
            case 2:
                data = (_f.sent());
                items = (_d = (_c = data.onixCodetableItems) !== null && _c !== void 0 ? _c : data.items) !== null && _d !== void 0 ? _d : [];
                total = (_e = data.totalRecords) !== null && _e !== void 0 ? _e : items.length;
                return [2 /*return*/, {
                        onixCodetableItems: items,
                        totalRecords: total,
                    }];
        }
    });
}); };
export var fetchOnixCodetableById = function (ky, id) { return __awaiter(void 0, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, ky.get("onix-codetables/".concat(encodeURIComponent(id)), {
                    headers: getHeaders(),
                })];
            case 1:
                res = _a.sent();
                if (!res.ok) {
                    throw new Error("Fetch error: ".concat(res.status, " ").concat(res.statusText));
                }
                return [2 /*return*/, res.json()];
        }
    });
}); };
export var fetchOnixCodetableItemById = function (ky, id) { return __awaiter(void 0, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, ky.get("onix-codetable-items/".concat(encodeURIComponent(id)), {
                    headers: getHeaders(),
                })];
            case 1:
                res = _a.sent();
                if (!res.ok) {
                    throw new Error("Fetch error: ".concat(res.status, " ").concat(res.statusText));
                }
                return [2 /*return*/, res.json()];
        }
    });
}); };
export var createOnixCodetable = function (ky, payload) { return __awaiter(void 0, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, ky.post("onix-codetables", {
                    json: payload,
                    headers: getHeaders(),
                })];
            case 1:
                res = _a.sent();
                if (!res.ok) {
                    throw new Error("Create error: ".concat(res.status, " ").concat(res.statusText));
                }
                return [2 /*return*/, res.json()];
        }
    });
}); };
/**
 * Loads one codetable without its items (id, number, name, version) — for
 * labels and the codetable edit form. Uses the uncached detail endpoint with
 * `includeItems=false`, so the `version` is current on every replica (the list
 * endpoint is cached per pod).
 *
 * @param ky okapi ky instance
 * @param id codetable id
 * @returns the codetable, or null when no codetable has the id (404)
 */
export var fetchOnixCodetableSummary = function (ky, id) { return __awaiter(void 0, void 0, void 0, function () {
    var res, error_1;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 3, , 4]);
                return [4 /*yield*/, ky.get("onix-codetables/".concat(encodeURIComponent(id)), {
                        searchParams: { includeItems: "false" },
                        headers: getHeaders(),
                    })];
            case 1:
                res = _b.sent();
                return [4 /*yield*/, res.json()];
            case 2: return [2 /*return*/, _b.sent()];
            case 3:
                error_1 = _b.sent();
                if (((_a = error_1.response) === null || _a === void 0 ? void 0 : _a.status) === 404) {
                    return [2 /*return*/, null];
                }
                throw error_1;
            case 4: return [2 /*return*/];
        }
    });
}); };
var toCodetableRef = function (table) { return ({
    id: table.id,
}); };
export var createOnixCodetableItem = function (ky, data) { return __awaiter(void 0, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, ky.post("onix-codetable-items", {
                    json: __assign(__assign(__assign(__assign({}, (data.id ? { id: data.id } : {})), { onixCodetable: toCodetableRef(data.onixCodetable), value: data.value, description: data.description, notes: data.notes }), (data.sortOrder != null ? { sortOrder: data.sortOrder } : {})), { version: data.version }),
                    headers: getHeaders(),
                })];
            case 1:
                res = _a.sent();
                if (!res.ok) {
                    throw new Error("Create error: ".concat(res.status, " ").concat(res.statusText));
                }
                return [2 /*return*/, res.json()];
        }
    });
}); };
export var updateOnixCodetableItem = function (ky, id, data) { return __awaiter(void 0, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, ky.put("onix-codetable-items/".concat(encodeURIComponent(id)), {
                    json: __assign(__assign(__assign(__assign({}, (data.onixCodetable
                        ? { onixCodetable: toCodetableRef(data.onixCodetable) }
                        : {})), { id: id, value: data.value, description: data.description, notes: data.notes }), (data.sortOrder != null ? { sortOrder: data.sortOrder } : {})), { version: data.version }),
                    headers: getHeaders(),
                })];
            case 1:
                res = _a.sent();
                if (!res.ok) {
                    throw new Error("Update error: ".concat(res.status, " ").concat(res.statusText));
                }
                return [2 /*return*/];
        }
    });
}); };
export var updateOnixCodetable = function (ky, id, updates) { return __awaiter(void 0, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, ky.put("onix-codetables/".concat(encodeURIComponent(id)), {
                    json: updates,
                    headers: getHeaders(),
                })];
            case 1:
                res = _a.sent();
                if (!res.ok) {
                    throw new Error("Update error: ".concat(res.status, " ").concat(res.statusText));
                }
                return [2 /*return*/];
        }
    });
}); };
/** React-query key prefix shared by all "codetable items by number" queries. */
export var ONIX_CODETABLE_ITEMS_BY_NUMBER_KEY = "onix-codetable-items-by-number";
/** ONIX codetables are static reference data: keep them cached for an hour. */
export var ONIX_CODETABLE_CACHE_MS = 60 * 60 * 1000;
export var useOnixCodetableByNumber = function (onixCodetableNumber) {
    var ky = useOkapiKy();
    // a codetable can have several hundred items (Language: ~580) — loaded page
    // by page within the list limit, then cached for an hour
    return useQuery([ONIX_CODETABLE_ITEMS_BY_NUMBER_KEY, onixCodetableNumber], function () { return __awaiter(void 0, void 0, void 0, function () {
        var items;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (onixCodetableNumber == null) {
                        return [2 /*return*/, { onixCodetableItems: [], totalRecords: 0 }];
                    }
                    return [4 /*yield*/, fetchAllPages(function (offset, limit) { return __awaiter(void 0, void 0, void 0, function () {
                            var page;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, fetchOnixCodetableItems(ky, {
                                            onixCodetableNumber: onixCodetableNumber,
                                            offset: offset,
                                            limit: limit,
                                        })];
                                    case 1:
                                        page = _a.sent();
                                        return [2 /*return*/, {
                                                items: page.onixCodetableItems,
                                                totalRecords: page.totalRecords,
                                            }];
                                }
                            });
                        }); })];
                case 1:
                    items = _a.sent();
                    return [2 /*return*/, { onixCodetableItems: items, totalRecords: items.length }];
            }
        });
    }); }, {
        enabled: !!onixCodetableNumber,
        staleTime: ONIX_CODETABLE_CACHE_MS,
        cacheTime: ONIX_CODETABLE_CACHE_MS,
    });
};
/**
 * Keeps the per-number entries seeded by {@link useOnixCodetablesByNumbers}
 * for an hour even without an observer — `setQueryData` would otherwise give
 * them the client's default cacheTime (1 ms) and they would be dropped before
 * a later `useOnixCodetableByNumber` could reuse them.
 */
var keepOnixCodetablesCached = function (queryClient) {
    queryClient.setQueryDefaults([ONIX_CODETABLE_ITEMS_BY_NUMBER_KEY], {
        staleTime: ONIX_CODETABLE_CACHE_MS,
        cacheTime: ONIX_CODETABLE_CACHE_MS,
    });
};
/**
 * Loads several ONIX codetables with their items in one request (see
 * {@link fetchOnixCodetablesByNumbers}) and stores every table also under its
 * `useOnixCodetableByNumber` key, so a single-table consumer mounted later
 * reuses it. The key shares the {@link ONIX_CODETABLE_ITEMS_BY_NUMBER_KEY}
 * prefix, so invalidating codetable items reloads this query too.
 *
 * @param numbers codetable numbers to load
 * @returns the react-query result with items keyed by codetable number
 */
export var useOnixCodetablesByNumbers = function (numbers) {
    var ky = useOkapiKy();
    var queryClient = useQueryClient();
    var requested = normalizeCodetableNumbers(numbers);
    return useQuery([ONIX_CODETABLE_ITEMS_BY_NUMBER_KEY, "bulk", requested], function () { return __awaiter(void 0, void 0, void 0, function () {
        var byNumber;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchOnixCodetablesByNumbers(ky, requested)];
                case 1:
                    byNumber = _a.sent();
                    keepOnixCodetablesCached(queryClient);
                    requested.forEach(function (n) {
                        queryClient.setQueryData([ONIX_CODETABLE_ITEMS_BY_NUMBER_KEY, n], byNumber[n]);
                    });
                    return [2 /*return*/, byNumber];
            }
        });
    }); }, {
        enabled: requested.length > 0,
        staleTime: ONIX_CODETABLE_CACHE_MS,
        cacheTime: ONIX_CODETABLE_CACHE_MS,
    });
};
/** Alias kept for backwards compatibility; shares the cache with `useOnixCodetableByNumber`. */
export var useGetOnixTableItemByNumber = useOnixCodetableByNumber;
